import initialState from './providerPlanInitialState';
import actions from './providerPlanAction';
import mutations from './providerPlanMutation';

const getters = {
};

const providerPlanModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default providerPlanModule;
